import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

interface IMyProps {
  show: boolean;
  handleExcluir: (e: React.MouseEvent<HTMLButtonElement>) => void;
  handleHide: (
    e:
      | React.FormEvent<HTMLFormElement>
      | React.MouseEvent<HTMLButtonElement>
      | HTMLElement,
  ) => void;
  mensagemPersonalizada?: string;
}

export default function ModalExcluir({
  show,
  handleExcluir,
  handleHide,
  mensagemPersonalizada,
}: IMyProps) {
  return (
    <Modal
      show={show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onExit={handleHide}
    >
      <Modal.Header closeButton={false}>
        <Modal.Title id="contained-modal-title-vcenter">
          Excluir Registro
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          {mensagemPersonalizada ??
            'Tem certeza que deseja excluir esse registro?'}
        </p>
      </Modal.Body>
      <Modal.Footer className="text-left">
        <Button
          variant="primary"
          onClick={handleExcluir}
          className="btn-danger text-left"
        >
          Excluir
        </Button>
        <Button variant="secondary" onClick={handleHide}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
